import { CubeTexture, RGBAFormat } from "three";

/**
 * Die ReflectionMap ist eine globale Ressource, die von der drei.js Environment Map
 * und der @react-three/drei Environment-Komponente verwendet wird.
 *
 * Diese leere CubeTexture wird später zur Laufzeit durch die in der Scene definierte
 * Environment Map ersetzt.
 */
export const ReflectionMap = new CubeTexture();
// new CubeTextureLoader().load([
//     "/textures/px.jpg",
//     "/textures/nx.jpg",
//     "/textures/py.jpg",
//     "/textures/ny.jpg",
//     "/textures/pz.jpg",
//     "/textures/nz.jpg",
// ]);
ReflectionMap.format = RGBAFormat;

// Erlaube einfaches Updaten des ReflectionMap-Objekts
// Dies erleichtert die Integration mit der @react-three/drei Environment
export const updateReflectionMap = (envMap: CubeTexture) => {
  if (!envMap) return;

  // CubeTexture-Eigenschaften übernehmen
  Object.assign(ReflectionMap, envMap);

  // Falls nötig, Image-Daten kopieren
  if (envMap.image && envMap.image.length > 0) {
    ReflectionMap.image = envMap.image;
  }

  // Signalisieren, dass die Textur aktualisiert werden muss
  ReflectionMap.needsUpdate = true;
};
